var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTextGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 24,
    viewBox: "0 0 152 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REJEEM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.5294V0H10.7456C12.8947 0 14.7416 0.347339 16.2863 1.04202C17.8534 1.7367 19.0623 2.7451 19.913 4.06723C20.7637 5.36695 21.189 6.91317 21.189 8.70588C21.189 10.4762 20.7637 12.0112 19.913 13.3109C19.0623 14.5882 17.8534 15.5742 16.2863 16.2689C14.7416 16.9412 12.8947 17.2773 10.7456 17.2773H3.6938L6.64885 14.4874V23.5294H0ZM14.5402 23.5294L8.69723 14.958H15.7826L21.6591 23.5294H14.5402ZM6.64885 15.1933L3.6938 12.1345H10.3427C11.7306 12.1345 12.7604 11.8319 13.432 11.2269C14.126 10.6218 14.473 9.78151 14.473 8.70588C14.473 7.60784 14.126 6.7563 13.432 6.15126C12.7604 5.54622 11.7306 5.2437 10.3427 5.2437H3.6938L6.64885 2.18487V15.1933Z",
    fill: "#37BD6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6551 9.10924H44.5686V14.084H33.6551V9.10924ZM34.1252 18.3866H46.4155V23.5294H27.5435V0H45.9789V5.14286H34.1252V18.3866Z",
    fill: "#37BD6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9292 24C56.2055 24 54.6384 23.7087 53.228 23.1261C51.84 22.521 50.6871 21.6583 49.7693 20.5378L53.3959 16.2353C54.0228 17.042 54.672 17.6583 55.3436 18.084C56.0152 18.4874 56.7203 18.6891 57.4591 18.6891C59.4291 18.6891 60.4141 17.5462 60.4141 15.2605V5.14286H52.2878V0H66.9958V14.8571C66.9958 17.9272 66.2235 20.2241 64.6788 21.7479C63.1341 23.2493 60.8843 24 57.9292 24Z",
    fill: "#37BD6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2815 9.10924H91.195V14.084H80.2815V9.10924ZM80.7516 18.3866H93.0419V23.5294H74.1699V0H92.6053V5.14286H80.7516V18.3866Z",
    fill: "#37BD6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.529 9.10924H116.443V14.084H105.529V9.10924ZM106 18.3866H118.29V23.5294H99.4179V0H117.853V5.14286H106V18.3866Z",
    fill: "#37BD6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.666 23.5294V0H130.139L139.878 16H136.99L146.459 0H151.933L152 23.5294H145.888L145.821 9.31092H146.862L139.777 21.2101H136.822L129.535 9.31092H130.811V23.5294H124.666Z",
    fill: "#37BD6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextGreen);
export default __webpack_public_path__ + "static/media/LogoText-green.22af91d183d1efa3638fb2eed34b6e7e.svg";
export { ForwardRef as ReactComponent };